import { render, staticRenderFns } from "./EditSubworkModal.vue?vue&type=template&id=715e609e"
import script from "./EditSubworkModal.vue?vue&type=script&lang=js"
export * from "./EditSubworkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports